import { render } from "./UploaderUrl.vue?vue&type=template&id=39b97cf6"
import script from "./UploaderUrl.vue?vue&type=script&lang=js"
export * from "./UploaderUrl.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__